import {  createContext, useContext, useEffect, useState } from "react";
import { callApi } from "../services/ApiServices";
import Cookies from "js-cookie";

const ClubsContext = createContext();

export const ClubsProvider = ({children})=>{
  const [selectedClub, setSelectedClub] = useState(null);
    const[clubId, setClubId] = useState("");
    const[userRole, setUserRole] = useState(Cookies.get("AccessPermission") || "");



      const handleSelectedClubDetail = async(club) => {
        try{
          const response = await callApi({
            method:"get",
            url:`club/detail/${club.id}`
          })
          setSelectedClub(response)
          console.log(" detail", response)
          return response
        }catch(error){
          console.log("error while fetching club details", error)
        }
      };

      useEffect(() => {
  const token = Cookies.get("Admin_Token");

  if (!token) return;

  const fetchProfile = async () => {
    try {
      const response = await callApi({
        method: "get",
        url: "admin/profile",
      });

      setUserRole(response?.data?.access_permission);
    } catch (error) {
      console.log("Profile error", error);
    }
  };

  fetchProfile();
}, []);

    const value = {
        selectedClub, setSelectedClub,
        clubId, setClubId,
        handleSelectedClubDetail,
        setUserRole,
        userRole,

    };

    return (
        <ClubsContext.Provider value={value}>
            {children}
        </ClubsContext.Provider>
    )
}

export const useGlobalStates = ()=> useContext(ClubsContext)